import { FieldViewModel, IGenericPlan, Datalayer, IDataLayer, IDatalayerEditModel, LayerTypeId } from "../omnia"
import { IGenericPlanContext } from "./types"

import m = omnia.models

export function getUpdateModel(args: {
    session: { holdingId: number, yearId: number },
    layer: Datalayer,
    target: IDataLayer,
    cropping: FieldViewModel,
    plan?: IGenericPlanContext
}) {

    const { session, layer, target, cropping, plan } = args

    let model: IDatalayerEditModel = {

        SessionHoldingId: session.holdingId,
        SessionYearId: session.yearId,

        DataLayerId: target.DataLayerId,

        TypeId: target.Type.TypeId,
        SubtypeId: target.SubtypeId,
        Calculated: target.Calculated,

        Unit: target.Unit,

        FirstYearId: target.FirstYearId,
        Date: target.Date,

        GeometryType: m.MapGeometryType.Polygon,

        HoldingId: target.HoldingId,
        FieldId: target.FieldId,
        CroppingId: cropping ? cropping.croppingId : null,

        Name: target.Name,
        Value: target.Value,

        CropId: target.Crop ? target.Crop.CropId : null,

        ClipFeatures: target.ClipFeatures,

        Zones: layer.getUpdateModels(),

        GenericPlanId: plan ? plan.id : target.GenericPlanId,
        GenericPlan: getGenericPlanModel(plan),

    }

    model.SubtypeId = model.SubtypeId || getDefaultSubtype(model);

    return model

}

function getGenericPlanModel(ctxt: IGenericPlanContext) {

    if (ctxt && hasPlanChanged(ctxt)) {

        return <IGenericPlan>{
            GenericPlanId: ctxt.id,
            Name: ctxt.name,
            ProductName: ctxt.productName,
            Units: ctxt.units,
            Labels: ctxt.getLabels()
        }

    }

}

function hasPlanChanged(ctxt: IGenericPlanContext) {
    if (!ctxt.id) return true
    const { plan } = ctxt
    return (plan.Name != ctxt.name) || (plan.ProductName != ctxt.productName) || (plan.Units != ctxt.units) || (!comparePlanLabels(plan.Labels, ctxt))
}

function comparePlanLabels(labels: { [value: string]: string } = {}, ctxt: IGenericPlanContext) {

    const updatedLabels = ctxt.getLabels() || {}

    const k1 = Object.keys(updatedLabels)
    const k2 = Object.keys(labels)

    return ((k1.length == k2.length) && k1.every(k => updatedLabels[k] === labels[k]))

}

function getDefaultSubtype(model: IDatalayerEditModel): number {

    switch (model.TypeId) {
        case LayerTypeId.Yield:
            if (model.CroppingId) return m.YieldLayerSubtype.TargetYield;
            return m.YieldLayerSubtype.ActualYield;
    }

}
